module.exports = __webpack_public_path__ + "img/GSB.c30802b9.png";